export default __webpack_public_path__ + "static/media/Arduino-eletronics.6622b556.svg";